import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function Atelier({navigateWithTransition}) {




return (

<div className="Atelier">




</div>

)

}